import type { AlertCondition, RangeKey } from '@/api/types';

export const CONDITIONS: { value: AlertCondition; label: string; pct: boolean }[] = [
  { value: 'above', label: 'Goes above', pct: false },
  { value: 'below', label: 'Drops below', pct: false },
  { value: 'change_up_pct', label: 'Rises by at least', pct: true },
  { value: 'change_down_pct', label: 'Falls by at least', pct: true },
  { value: 'change_pct', label: 'Moves either way by at least', pct: true },
];

export const WINDOW_LABEL: Record<RangeKey, string> = {
  today: 'today vs yesterday',
  '7d': 'last 7 days vs the 7 before',
  '30d': 'last 30 days vs the 30 before',
};

export function isPct(c: AlertCondition): boolean {
  return CONDITIONS.find((x) => x.value === c)?.pct ?? false;
}

export function conditionText(c: AlertCondition, threshold: number, formatted?: string): string {
  const label = CONDITIONS.find((x) => x.value === c)?.label.toLowerCase() ?? c;
  return `${label} ${isPct(c) ? `${threshold}%` : (formatted ?? String(threshold))}`;
}
